export const allergyTypes = ['drug', 'food']

export const AllergyTypeDisplay = {
  drug: 'Drug',
  food: 'Food/Other',
}
